var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ConditionsBuilder from '@project/components/LogicalConditions';
import { propertiesToArray, flattenArray, } from '../../containers/StructureBuilderPage/helpers';
var ConditionalModal = function (_a) {
    var _b, _c;
    var handleChange = _a.handleChange, settings = _a.settings, functionName = _a.functionName, onModalOpenButtonClicked = _a.onModalOpenButtonClicked;
    var generateCorrectType = function (type) {
        switch (type) {
            case 'string':
            case 'url':
            case 'richtext':
            case 'image':
            case 'link':
            case 'file':
                return 'text';
            case 'integer':
            case 'float':
                return 'number';
            case 'timestamp':
            case 'time':
                return 'datetime';
            default:
                return type;
        }
    };
    var conditions = Object.keys(((_b = settings === null || settings === void 0 ? void 0 : settings.condition) === null || _b === void 0 ? void 0 : _b.keys) || {}).map(function (item) {
        var _a;
        var _b;
        var selectedItem = (_b = settings === null || settings === void 0 ? void 0 : settings.condition) === null || _b === void 0 ? void 0 : _b.keys[item];
        if (generateCorrectType(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.type) === 'text') {
            return {
                name: item.replace(/\s/g, '-'),
                label: "".concat(item, "-(").concat(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.type, ")"),
                type: generateCorrectType(selectedItem.type),
                operators: [
                    'equal',
                    'not_equal',
                    'like',
                    'not_like',
                    'is_empty',
                    'is_not_empty',
                ],
                valueSources: ['value', 'field'],
            };
        }
        if (generateCorrectType(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.type) === 'number') {
            return {
                name: item.replace(/\s/g, '-'),
                label: "".concat(item, "-(").concat(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.type, ")"),
                type: generateCorrectType(selectedItem.type),
                valueSources: ['value', 'field'],
                operators: [
                    'equal',
                    'not_equal',
                    'less',
                    'less_or_equal',
                    'greater',
                    'greater_or_equal',
                    'remainder',
                    'between',
                    'not_between',
                    'is_empty',
                    'is_not_empty',
                ],
            };
        }
        if (selectedItem.type === 'coordinates' ||
            selectedItem.type === 'location') {
            return {
                name: item.replace(/\s/g, '-'),
                label: "".concat(item, "-(").concat(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.type, ")"),
                type: '!group',
                subfields: {
                    lat: {
                        type: 'number',
                        label: 'Latitude',
                        valueSources: ['value', 'field'],
                        mainWidgetProps: {
                            valueLabel: 'lat',
                            valuePlaceholder: 'Latitude',
                        },
                    },
                    lon: {
                        type: 'number',
                        label: 'Longitude',
                        valueSources: ['value', 'field'],
                        mainWidgetProps: {
                            valueLabel: 'lon',
                            valuePlaceholder: 'Longitude',
                        },
                    },
                },
            };
        }
        if (generateCorrectType(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.type) === 'json') {
            var formattedObj = (_a = {},
                _a[selectedItem.key] = __assign({}, selectedItem.value),
                _a);
            var itemList = propertiesToArray(formattedObj) || [];
            return itemList.map(function (itm) {
                var jsonType = generateCorrectType(itm.type);
                var field = {
                    name: itm.id,
                    label: "".concat(itm.id, "-(").concat(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.type, ")"),
                    type: jsonType,
                    valueSources: ['value', 'field'],
                };
                if (jsonType === 'text') {
                    field.operators = [
                        'equal',
                        'not_equal',
                        'like',
                        'not_like',
                        'is_empty',
                        'is_not_empty',
                    ];
                }
                else if (jsonType === 'number') {
                    field.operators = [
                        'equal',
                        'not_equal',
                        'less',
                        'less_or_equal',
                        'greater',
                        'greater_or_equal',
                        'like',
                        'not_like',
                        'is_empty',
                        'is_not_empty',
                    ];
                }
                return field;
            });
        }
        return {
            name: item.replace(/\s/g, '-'),
            label: "".concat(item, "-(").concat(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.type, ")"),
            type: generateCorrectType(selectedItem.type),
            valueSources: ['value', 'field'],
        };
    });
    if (conditions.length === 0)
        return null;
    var formattedConditions = flattenArray(conditions);
    return (_jsx(ConditionsBuilder, { columns: formattedConditions, value: ((_c = settings.condition) === null || _c === void 0 ? void 0 : _c.value) || false, handleChange: handleChange, functionName: functionName, onModalOpenButtonClicked: onModalOpenButtonClicked }));
};
export default ConditionalModal;
